// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import { GalleryController } from "./gallery_controller";
import { HeroController } from "./hero_controller";
import { NavbarController } from "./navbar_controller";
import { RemovalsController } from "./removals_controller";
import { ScrollSpyController } from "./scrollspy_controller";
import { VisibilityController } from "./visibility_controller";

application.register("gallery", GalleryController);
application.register("hero", HeroController);
application.register("navbar", NavbarController);
application.register("removals", RemovalsController);
application.register("scrollspy", ScrollSpyController);
application.register("visibility", VisibilityController);
